import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {Model} from "../Model";

@usingJsonToModelConvertor
export class LoginResponse extends Model{

    @fromJsonObject({key: 'already_signed'})
    public alreadySigned! : boolean;

}